import { LandingPro } from '../../events-interfaces/landings';
import { ANALYTIC_EVENT_EVENTS, ANALYTIC_EVENT_TYPES, GIFTCARDS } from '../../constants';

export const getLandingProLabel = (eventLabel: string): LandingPro => {
  return {
    event: ANALYTIC_EVENT_TYPES.OWOX,
    eventCategory: GIFTCARDS,
    eventAction: ANALYTIC_EVENT_EVENTS.submit,
    eventLabel: eventLabel,
  };
};
